import {NgModule} from '@angular/core';
import {CustomSettingsDialogHeaderComponent} from '@presentation/components/custom-settings-dialog/custom-settings-dialog-header.component';
import {PlasticProductSelectionModule} from '@presentation/pages/textile-data/plastic-product/plastic-product-selection.module';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {CrudOverviewDataModule, EditorHeaderModule, SplitButtonModule} from '@vdw/angular-component-library';
import {AddToolPageComponent} from './add/add-tool-page.component';
import {CavitiesComponent} from './add/cavities/cavities.component';
import {MatchingCriteriaModule} from './add/matching-criteria/matching-criteria.module';
import {ProductsComponent} from './add/products/products.component';
import {SetupComponent} from './add/setup/setup.component';
import {AddStockLocationComponent} from './add/tool-status/add-stock-location/add-stock-location.component';
import {ToolStatusComponent} from './add/tool-status/tool-status.component';
import {ToolOverviewPageComponent} from './overview/tool-overview-page.component';
import {ToolCustomSettingsComponent} from './settings/tool-custom-settings.component';
import {toolRouting} from './tool.routing';

@NgModule({
  imports: [
    TextileDataSharedModule,
    MatchingCriteriaModule,
    toolRouting,
    EditorHeaderModule,
    CrudOverviewDataModule,
    SplitButtonModule,
    PlasticProductSelectionModule,
    CustomSettingsDialogHeaderComponent
  ],
  declarations: [AddToolPageComponent, CavitiesComponent, SetupComponent, ToolStatusComponent, ToolOverviewPageComponent, AddStockLocationComponent, ProductsComponent, ToolCustomSettingsComponent]
})
export class ToolModule {}
